import styled, { css } from 'styled-components'

export const FileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--space-500);
`

export const File = styled.div`
  line-height: var(--font-line-height-400);
  font-size: var(--font-size-400);
  display: flex;
  align-items: center;
`

export const FileWarning = styled.div`
  padding-left: var(--space-1000);
  font-size: var(--font-size-200);
  letter-spacing: 0.24px;
  color: var(--text-alert-secondary);
  display: flex;
  align-items: center;
  gap: var(--space-150);
`

export const FileIcon = styled.div`
  margin-right: var(--space-400);
`

export const FileName = styled.div`
  margin-right: var(--space-800);
  position: relative;
  height: 24px;
  flex: 1;
`
export const FileNameWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FileSize = styled.div<{ $withoutMargin: boolean }>`
  margin-right: var(--space-800);
  text-align: right;
  min-width: 100px;

  ${({ $withoutMargin }) =>
    $withoutMargin &&
    css`
      margin-right: 0;
    `}
`

export const BannerWrapper = styled.div`
  margin-bottom: var(--space-500);
`

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`
